import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import BookSiteWalkModal from "./BookSiteWalkModal";

/**
 * SiteWalkTrigger — floating pill CTA at bottom-center of viewport.
 * Opens the 3-step Book a Site Walk wizard.
 * Auto-hides on very small screens (persistent CTA already covers mobile).
 */
export default function SiteWalkTrigger() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <AnimatePresence>
        {!open && (
          <motion.button
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ delay: 1.6, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            onClick={() => setOpen(true)}
            className="hidden md:flex fixed z-[80] items-center gap-3 px-5 py-3 group"
            style={{
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              borderRadius: "999px",
              background: "linear-gradient(180deg, rgba(20,20,24,0.9), rgba(10,10,13,0.95))",
              border: "1px solid var(--line-gold)",
              boxShadow: "0 24px 48px -16px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.03) inset, 0 0 40px rgba(198,168,124,0.12)",
              backdropFilter: "blur(14px)",
              WebkitBackdropFilter: "blur(14px)",
              color: "var(--gold-2)",
            }}
            data-testid="sitewalk-trigger"
            data-cursor="hover"
            data-cursor-label="Book"
          >
            <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{
              background: "var(--gold)", color: "#0a0a0d",
              boxShadow: "0 0 12px rgba(198,168,124,0.6)",
            }}>
              <CalendarCheck size={12} strokeWidth={2} />
            </div>
            <span className="font-mono text-[10px] uppercase tracking-[0.32em]">
              Book a Site Walk · 30s
            </span>
            <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#4ade80" }} />
          </motion.button>
        )}
      </AnimatePresence>
      <BookSiteWalkModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
